import { Route } from "lucide-react";
import { OCEAN_RATE_SCOPE } from "../../utils/constant";
import SectionCard from "./SectionCard";

// Toggle chips for which legs this rate covers. Purely a `values.scope`
// boolean map on the Formik state — Origin/Destination info sections read
// the relevant flags to decide which fields are required.
const RateScopeSection = ({ formikData, complete, readOnly }) => {
  const { values, setFieldValue } = formikData;
  const scope = values.scope || {};
  const allOn = OCEAN_RATE_SCOPE.every((item) => scope[item.key]);

  const setAll = (val) => {
    OCEAN_RATE_SCOPE.forEach((item) => setFieldValue(`scope.${item.key}`, val));
  };

  return (
    <SectionCard
      id="scope-section"
      icon={Route}
      title="Rate scope"
      subtitle="Toggle the legs this rate covers"
      complete={complete}
      right={
        !readOnly && (
          <button
            type="button"
            onClick={() => setAll(!allOn)}
            className="text-xs font-semibold px-3 py-1.5 rounded-lg border border-gray-200 text-gray-600 bg-white hover:bg-gray-50 transition-colors"
          >
            {allOn ? "Clear all" : "Select all"}
          </button>
        )
      }
    >
      <div className="oc-scroll" style={{ display: "flex", overflowX: "auto", paddingBottom: 4 }}>
        {OCEAN_RATE_SCOPE.map((item, i) => {
          const checked = !!scope[item.key];
          return (
            <div
              key={item.key}
              style={{ display: "flex", alignItems: "center", flex: 1, minWidth: 112 }}
            >
              <button
                type="button"
                disabled={readOnly}
                onClick={() => setFieldValue(`scope.${item.key}`, !checked)}
                className="transition-transform hover:scale-105 disabled:cursor-not-allowed disabled:hover:scale-100"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 9,
                  cursor: readOnly ? "not-allowed" : "pointer",
                  flex: "none",
                  width: 108,
                  textAlign: "center",
                  background: "none",
                  border: "none",
                  padding: "4px 0",
                }}
              >
                <span
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 9,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flex: "none",
                    transition: "all .15s",
                    background: checked ? "#F5A623" : "#fff",
                    border: checked ? "1px solid #F5A623" : "1.6px solid #E1E4EA",
                    boxShadow: checked ? "0 3px 8px rgba(245,166,35,.35)" : "none",
                  }}
                >
                  {checked && (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                  )}
                </span>
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    lineHeight: 1.25,
                    color: checked ? "#1f2937" : "#9AA2B1",
                  }}
                >
                  {item.label}
                </span>
              </button>
              {i < OCEAN_RATE_SCOPE.length - 1 && (
                <span style={{ flex: 1, height: 2, background: "#EEF0F3", marginTop: -18 }} />
              )}
            </div>
          );
        })}
      </div>
    </SectionCard>
  );
};

export default RateScopeSection;
